export var SDK_VERSION = '6.10.0';